<template>
<v-container fluid>
    <v-card flat>
        <v-row :class="{'pa-3': $vuetify.breakpoint.mdAndUp, 'pa-1': $vuetify.breakpoint.smAndDown }" align="center" no-gutters>
            <slot name="left-content">
                <v-col cols="9">
                    <div class="major font-weight-medium text-truncate">
                        <slot name="title">
                            Title
                        </slot>
                    </div>
                </v-col>
            </slot>
            <slot name="right-content">
                <v-col cols="3" class="text-right">
                    <slot name="button">
                        <v-btn :class="{'add-shine-btn':$vuetify.breakpoint.smAndUp}" color="green" :small="$vuetify.breakpoint.smAndDown" outlined rounded @click="emitAdd()">
                            <slot name="button-name">
                                Adauga
                            </slot>
                        </v-btn>
                    </slot>
                </v-col>
            </slot>
        </v-row>
        <v-progress-linear v-if="loading" :indeterminate="true" height="3" class="ma-0 progress-bar"></v-progress-linear>
    </v-card>
</v-container>
</template>

<script>
export default {
    name: "IMheader",
    props: {
        loading: {
            type: Boolean,
            default: false
        },
    },

    methods: {
        emitAdd() {
            this.$emit('add');
        },
    }
}
</script>
